/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionIssuersGetDeletePreflight } from "../funcs/organizationRemoteSessionIssuersGetDeletePreflight.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationIssuerDeletePreflight } from "../models/components/organizationissuerdeletepreflight.js";
import {
  GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
  GetOrganizationRemoteSessionIssuerDeletePreflightSecurity,
} from "../models/operations/getorganizationremotesessionissuerdeletepreflight.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionIssuerDeletePreflightQueryData =
  OrganizationIssuerDeletePreflight;

export function prefetchOrganizationRemoteSessionIssuerDeletePreflight(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionIssuerDeletePreflightSecurity
    | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionIssuerDeletePreflightQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionIssuerDeletePreflightQuery(
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionIssuerDeletePreflightSecurity
    | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionIssuerDeletePreflightQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuerDeletePreflight({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn:
      async function organizationRemoteSessionIssuerDeletePreflightQueryFn(
        ctx,
      ): Promise<OrganizationRemoteSessionIssuerDeletePreflightQueryData> {
        const sig = combineSignals(
          ctx.signal,
          options?.signal,
          options?.fetchOptions?.signal,
        );
        const mergedOptions = {
          ...options?.fetchOptions,
          ...options,
          signal: sig,
        };

        return unwrapAsync(organizationRemoteSessionIssuersGetDeletePreflight(
          client$,
          request,
          security,
          mergedOptions,
        ));
      },
  };
}

export function queryKeyOrganizationRemoteSessionIssuerDeletePreflight(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "getDeletePreflight",
    parameters,
  ];
}
